import {LegacyPeriodReportBoundary} from "./Layout/LegacyPeriodReportBoundary.jsx";
import React from "react";
import {useTranslation} from "react-i18next";
import OrderDashboardLayout from "./Layout/OrderDashboardLayout.jsx";
import ChannelGrid from "../MarketingChannelGrids/ChannelGrid.jsx";
import {GridType} from "../MarketingChannelGrids/channelGridColumnSetup.js";
import CampaignOrderBasis from "./TablesAndGraphs/ByFilter/CampaignOrderBasis.jsx";


function OrderMarketingProfitabilityOverviewContent({project}) {
    let {t} = useTranslation();

    // noinspection JSValidateTypes
    return <OrderDashboardLayout title={t('route.campaign-profitability')} showMarketingFilters={true} showModeSwitch={false}>
            <div className="col-span-12 mb-2"><CampaignOrderBasis isMarketing={true}/></div>
            <ChannelGrid project={project} gridType={GridType.MarketingProfitability} metricContext="marketing"/>
    </OrderDashboardLayout>;
}

export default function OrderMarketingProfitabilityOverview(props) {
    return <LegacyPeriodReportBoundary project={props.project}><OrderMarketingProfitabilityOverviewContent {...props}/></LegacyPeriodReportBoundary>;
}
